import { Popup } from '../../../../ui/popup/popup';
import React from 'react';
import {rootActions, useAppDispatch, useAppSelector} from '../../DAL/store';
import ProductPriceFormat from "../../../products/product-price/product-price-format";

const TwoMonthFreePopup = () => {
    const dispatch = useAppDispatch();

    const PlanSavePopupShown = useAppSelector((store) => store.PlanSavePopupShown);
    const PlanCostPopupShown = useAppSelector((store) => store.PlanCostPopupShown);

    const closePopup = () => {
        dispatch(
            rootActions.main({
                IsTwoMonthFreePopupShown: false,
                PlanCostPopupShown: null,
                PlanSavePopupShown: null
            })
        );
    };

    return (
        <Popup width="320px" height="200px" close={ closePopup }>
            <div className="flex flex-col justify-center items-center w-full h-full text-center">
                <p className="mb-4">By paying <ProductPriceFormat price={ PlanCostPopupShown ?? 0 } /> upfront annually, you save <ProductPriceFormat price={ PlanSavePopupShown ?? 0 } />  compared to paying monthly.</p>
                <button className="w-btn w-auto px-10" type="button" onClick={ closePopup }>OK</button>
            </div>
        </Popup>
    )
};

export default TwoMonthFreePopup;